import { useEffect, useRef } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { RouterPathes } from 'shared/constants/router-paths'
import { track } from './track'

const ROUTE_TEMPLATES = [
  ...Object.values(RouterPathes),
  `${RouterPathes.profile}/:id`
]

/** The template of the route `pathname` matches; `*` for an unknown page. */
const getRouteTemplate = (pathname: string) =>
  ROUTE_TEMPLATES.find(template => matchPath(template, pathname)) ?? '*'

/**
 * Reports `page_view` with the route template on every route change
 * (FE-321): the template groups pages the way the router does, while the
 * URL itself travels in the event's `page`. Mounted once at the app root,
 * inside the router.
 *
 * Only the pathname counts: a search or hash change is not a page view.
 */
export const PageViewEffect = () => {
  const { pathname } = useLocation()
  const reportedPathname = useRef<string | null>(null)

  useEffect(() => {
    // NOTE: the next tick, after the page's own effects have set
    // document.title, which the event carries
    const timer = setTimeout(() => {
      if (reportedPathname.current === pathname) return

      reportedPathname.current = pathname
      track('page_view', { route: getRouteTemplate(pathname) })
    })

    return () => clearTimeout(timer)
  }, [pathname])

  return null
}
